import { Compass } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { EmptyState } from '@/components/states/EmptyState';
import { ButtonLink } from '@/components/ui/Button';
import { useAuth } from '@/auth/useAuth';
import { homeFor } from '@/app/roleNav';

export function NotFoundPage() {
  const { user } = useAuth();

  return (
    <Card>
      <EmptyState
        icon={Compass}
        title="Page not found"
        description="That address does not exist, or you no longer have access to it."
        action={
          <ButtonLink to={homeFor(user?.role ?? null)} variant="primary" size="sm">
            Back to safety
          </ButtonLink>
        }
      />
    </Card>
  );
}
